import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { TextInput } from 'nhsuk-react-components';
import isNino from 'is-national-insurance-number';

const NINumber = forwardRef((props, ref) => {
    const [error, setError] = useState(undefined);
    const [isValid, setIsValid] = useState(undefined);

    useEffect(() => {
        validate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.question.value]);

    useImperativeHandle(ref, () => ({
        validate,
        isValid
    }));

    const validate = () => {
        const value = getValue();
        const questionName = props.question.name;

        let errorMessage;
        let isValid = true;

        if (props.question.mandatory || value.length > 0) {
            if (!isNino(value)) {
                isValid = false;

                if (value.length === 0) {
                    errorMessage = `The ${questionName} is required`;
                } else if (value.length < 9) {
                    errorMessage = `The ${questionName} is too short`;
                } else if (value.length > 9) {
                    errorMessage = `The ${questionName} is too long`;
                } else {
                    errorMessage = `Enter ${questionName} in the correct format. For example, 'QQ123456C'`;
                }
            }
        }

        setError(errorMessage);
        setIsValid(isValid);
    };

    const getValue = () => {
        if (props.question.value === undefined) {
            props.question.value = null;
        }

        return props.question.value ?? '';
    };

    const handleChange = async event => {
        await props.onChange({
            questionId: props.question.id,
            value: event.target.value
        });

        validate();
    };

    const value = getValue();
    return (
        <TextInput
            id={props.id}
            label={props.question.name}
            hint={props.question.hint_text}
            error={error}
            type="text"
            width="10"
            value={value}
            onChange={handleChange}
            onBlur={handleChange}
            required={props.question.mandatory}
        />
    );
});

export default NINumber;
